<app-container>
	<div class="flex flex-col 2xl:flex-row flex-wrap justify-between mb-2 gap-4">
		<h4 class="mb-0">Mortgagee</h4>
		<app-radio-group
			type="compact"
			[items]="mortgageeTypeOptions"
			[ngModel]="_mortgagee?.mortgageeType"
			(ngModelChange)="setMortgageeType($event)"
		></app-radio-group>
	</div>

	<app-institution
		*ngIf="
			_mortgagee?.mortgageeType &&
			_mortgagee?.mortgageeType !== mortgageeTypes.PRIVATE_LENDER
		"
		[showCorrespondence]="false"
		[mortgagee]="_mortgagee"
		(updateMortgagee)="updateMortgagee($event)"
		[showDischargeFields]="showDischargeFields"
		[@openClose]
		[pushChangesToGlobalData]="pushChangesToGlobalData"
	>
	</app-institution>

	<app-private-lender
		*ngIf="_mortgagee?.mortgageeType === mortgageeTypes.PRIVATE_LENDER"
		[@openClose]
		[mortgagee]="_mortgagee"
		(updateMortgagee)="updateMortgagee($event)"
	>
	</app-private-lender>
</app-container>
